import classNames from "classnames";
import Flickity from "flickity-imagesloaded";
import React from "react";
import { check } from "tsi-common-react/src/models/utils";

import { ReviewsBlock as ReviewsBlockCodec } from "../models";

import styles from "./ReviewsBlock.module.scss";

interface IProps {
    reviewsBlockJSON: string;
    theme?: string;
}

interface IState {}

// TODO(ssr, LEVEL 5 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 5/10 due to Flickity carousel initialization in componentDidMount with conditional logic, DOM refs management, io-ts JSON decoding, and theme-based conditional rendering.
export class ReviewsBlock extends React.Component<IProps, IState> {
    private carousel: HTMLDivElement | null = null;
    private flickity: Flickity | null = null;
    private readonly THEME_STARS_BG = "theme--stars-and-bg";

    componentDidMount() {
        if (!this.carousel) {
            return;
        }
        if (!this.isStarsTheme() && this.carousel.childNodes.length > 1) {
            if (this.flickity) {
                this.flickity.destroy();
            }
            this.flickity = new Flickity(this.carousel, {
                watchCSS: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true,
            });
        }
    }

    private isStarsTheme() {
        return this.props.theme === this.THEME_STARS_BG;
    }

    private renderAuthor(author: string, location: string) {
        if (this.isStarsTheme()) {
            // TODO(i18n): Use t with interpolation to keep sentence together: {t`– ${author} in ${location}`}
            return (
                <>
                    – <em>{author}</em> in {location}
                </>
            );
        }
        // TODO(i18n): Use t with interpolation to keep sentence together: {t`${author}, ${location}`}
        return (
            <>
                <strong>{author}</strong>, {location}
            </>
        );
    }

    render() {
        const reviewsBlock = check(
            ReviewsBlockCodec.decode(JSON.parse(this.props.reviewsBlockJSON)),
        );
        const columnClasses = classNames({
            [styles.column]: true,
            [styles.columnThemeStars]: this.isStarsTheme(),
        });
        const contentClasses = classNames({
            [styles.content]: true,
            [styles.contentThemeStars]: this.isStarsTheme(),
        });
        const authorClasses = classNames({
            [styles.author]: true,
            [styles.authorThemeStars]: this.isStarsTheme(),
        });

        return (
            <div
                className={styles.columns}
                ref={(ref) => {
                    this.carousel = ref;
                }}
            >
                {reviewsBlock.reviews.map((review, i) => (
                    <div className={columnClasses} key={i}>
                        <div className={contentClasses}>{review.content}</div>
                        <div className={authorClasses}>
                            {this.renderAuthor(review.author, review.location)}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}
